import { Build, ComponentInterface } from "@stencil/core"

import { DuetTheme } from "../common-types"

export interface ThemeableComponent extends ComponentInterface {
  /**
   * Theme of the card. Can be one of: "default", "turva".
   */
  theme: DuetTheme
}

export const inheritGlobalTheme = (component: ThemeableComponent) => {
  // this is done in a complex way to support hydrate.renderToString
  const classList = document.documentElement.attributes.getNamedItem("class")?.value ?? ""
  const theme = /(duet-theme-)([a-z0-9]*)/gi.exec(classList)
  if (component.element) {
    component.element.classList.add("duet-theme-observer")
  }
  if (classList.includes("duet-theme-turva2")) {
    component.theme = "turva"
    if (component.element) {
      component.element.classList.add("duet-theme-turva2")
    }
    return
  }
  if (theme && theme[1] === "duet-theme-") {
    component.theme = theme[2] === "default" ? "" : (theme[2] as DuetTheme)
  }
}

const getObservingElements = (rootElement: {
  shadowRoot?: ShadowRoot
  querySelectorAll: (arg: string) => NodeList
}) => {
  const elements = Array.from(rootElement.querySelectorAll(".duet-theme-observer")) as unknown as ThemeableComponent[]
  if (rootElement.shadowRoot) {
    elements.push(...getObservingElements(rootElement.shadowRoot))
  }
  elements.forEach(nestedElement => {
    if (nestedElement.shadowRoot) {
      elements.push(...getObservingElements(nestedElement.shadowRoot))
    }
  })
  return elements
}

const setAllObservingElementsTheme = (mutations: MutationRecord[]) => {
  mutations.forEach(mutation => {
    if (!mutation.oldValue?.includes("hydrated")) {
      // only set theme once hydrated is set
      return
    }
    const classList = document.documentElement.attributes.getNamedItem("class")?.value ?? ""
    const themeParts = /(duet-theme-)([a-z0-9]*)/gi.exec(classList)
    const theme = themeParts?.length > 2 && themeParts[2].startsWith("turva") ? "turva" : ""
    const isTurva2 = classList.includes("duet-theme-turva2")
    const elements = getObservingElements(document.body)
    elements.forEach(el => {
      el.theme = theme
      if (isTurva2) {
        el.classList.add("duet-theme-turva2")
      } else {
        el.classList.remove("duet-theme-turva2")
      }
    })
  })
}
if (!Build.isServer) {
  const documentClassObserver = new MutationObserver(setAllObservingElementsTheme)
  documentClassObserver.observe(document.documentElement, {
    subtree: false,
    childList: false,
    characterData: false,
    attributes: true,
    attributeFilter: ["class"],
    attributeOldValue: true,
  })
}
